import React, { Component, ChangeEvent } from 'react';
import { CheckBoxListItem } from 'kb-web-shared';
import TextInput from '../../../components/TextInput/NewTextInput';

type State = {
  currentSelected: string;
  specifyOtherValue: string;
};

type Props = {
  setCancellationInformation: (parameters?: any) => void;
};

class CancellationSelection extends Component<Props, State> {
  state = {
    currentSelected: '',
    specifyOtherValue: ''
  };

  onSelect = (selectedValue: string) => {
    this.setState({ currentSelected: selectedValue });
    this.props.setCancellationInformation({
      reason: selectedValue,
      note: this.state.specifyOtherValue
    });
  };

  isSelected = (value: string) => {
    const { currentSelected } = this.state;
    return value === currentSelected;
  };

  onChangeSpecifyOther = (e: ChangeEvent<HTMLInputElement>) => {
    this.setState({ specifyOtherValue: e.target.value });
    this.props.setCancellationInformation({
      reason: this.state.currentSelected,
      note: e.target.value
    });
  };

  render() {
    const { specifyOtherValue } = this.state;
    return (
      <div>
        <CheckBoxListItem
          onSelect={this.onSelect}
          isSelected={this.isSelected}
          value="Changed my mind"
        >
          I changed my mind
        </CheckBoxListItem>
        <CheckBoxListItem
          onSelect={this.onSelect}
          isSelected={this.isSelected}
          value="No longer need this appointment"
        >
          I no longer need this appointment
        </CheckBoxListItem>
        <CheckBoxListItem
          onSelect={this.onSelect}
          isSelected={this.isSelected}
          value="Booked this appointment by accident"
        >
          I booked this appointment by accident
        </CheckBoxListItem>
        <CheckBoxListItem
          onSelect={this.onSelect}
          isSelected={this.isSelected}
          value="Can no longer make this time"
        >
          I can no longer make this time
        </CheckBoxListItem>
        <CheckBoxListItem
          onSelect={this.onSelect}
          isSelected={this.isSelected}
          value="Other - Specify"
        >
          Other
        </CheckBoxListItem>
        {this.isSelected('Other - Specify') && (
          <TextInput
            name="Specify"
            label="Reason"
            placeholder="Please specify a reason"
            value={specifyOtherValue}
            onChange={this.onChangeSpecifyOther}
          />
        )}
      </div>
    );
  }
}

export default CancellationSelection;
